// extracted by mini-css-extract-plugin
export var actionIcon = "_ok-0";